module.exports = __webpack_public_path__ + "static/media/dinosaur.5c4ec218.png";